// test1320
(1320 && 0);
